import {cva} from 'class-variance-authority'

/**
 * Popover surface (Figma "Popover", node 371:21911).
 * White `background` surface, 8px radius, 8px padding, `body2` (14px) `text-primary`
 * content. Default width 200px (Figma), overridable via `className` —
 * tailwind-merge resolves the override.
 *
 * - `default` — the authored atom: a 1px `info` (#00BACC) teal hairline.
 * - `menu` — borderless and elevated, matching the `Menu` surface
 *   (`shadow-elevation-1`). For popovers that *are* menus hanging off the dark
 *   brand shell, where the teal hairline reads as an off-brand blue.
 */
export const PopoverVariantsFactory = cva(
  'z-50 w-[200px] rounded-lg bg-background p-2 text-sm leading-[1.43] tracking-[0.17px] text-text-primary',
  {
    variants: {
      surface: {
        default: 'border border-info',
        menu: 'shadow-elevation-1',
      },
    },
    defaultVariants: {
      surface: 'default',
    },
  },
)
